import { RefObject } from 'react';
import { CommonFormField } from '../../../../components/Form/CommonFormField';
import {
  SelectAttributeInput,
  SelectAttributeInputProps,
} from '../../../../components/HeadlessComponents/SelectAttributeInput';

export type SelectAttributeFieldProps = Omit<SelectAttributeInputProps, 'error'> & {
  required?: boolean;
  error?: string;
  fieldRef?: RefObject<HTMLDivElement>;
};

/**
 * Layer B select field wrapper. Defaults `clearable` to `true` to match the
 * legacy in-form behavior — consumers can override via the input pass-through
 * props if they need a non-clearable variant.
 */
export const SelectAttributeField = ({
  attribute,
  required,
  error,
  fieldRef,
  clearable = true,
  ...inputProps
}: SelectAttributeFieldProps) => (
  <CommonFormField label={attribute.displayName} required={required} error={error} ref={fieldRef}>
    <SelectAttributeInput
      attribute={attribute}
      {...inputProps}
      clearable={clearable}
      error={!!error}
    />
  </CommonFormField>
);
